import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Autoplay } from "swiper/modules";

import ProductSliderComponentChild from "./productSliderComponent/ProductSliderComponentChild";

const ProductSlider = ({ data ,setData}) => {
  if (data && data.is_active)
    return (
      <div className="products-wrap mb-30">
        <h2 className="products-title">
          <a href="/site/products?featured=true&available=true&sorting=stats">
            <span className="text-dark"> {data.title} </span>
          </a>
        </h2>
        <div className="owl-container position-relative">
          <Swiper
            className="products-items "
            spaceBetween={10}
            autoplay={
              data.auto_play
                ? {
                    delay: 4000,
                    disableOnInteraction: false,
                  }
                : {}
            }
            speed={300}
            loop={true}
            dir="rtl"
            modules={data.auto_play ? [Autoplay] : []}
            breakpoints={{
              0: {
                slidesPerView: 1.3,
              },
              375: {
                slidesPerView: 2,
              },
              576: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 4,
              },
            }}
          >
            {data.items.map((item, index) => {
              return (
                <SwiperSlide key={`product_slider_${data.id + index}`}>
                  <ProductSliderComponentChild item={item} setData={setData}/>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    );
};

export default ProductSlider;
